<template>
    <main class="layout layout--cabinet">
        <l-c-header></l-c-header>
        <div class="content">
            <div class="cabinet">
                <aside class="cabinet__nav" v-if="isDesktop">
                    <c-menu></c-menu>
                    <div class="cabinet-calculator">
                        <calculator v-bind="product" v-if="showCalculator">
                            <template slot="button">
                                <button class="cabinet-calculator__button button button--yellow" v-on:click="goToCalculator">Оформить микрокредит</button>
                            </template>
                        </calculator>
                        <payment-shedule v-if="showPaymentShedule"></payment-shedule>
                    </div>
                </aside>
                <router-view></router-view>
            </div>
        </div>

        <!-- Modal block -->
        <payment-popup></payment-popup>
        <popup-payment-schedule></popup-payment-schedule>
        <!-- Modal block -->

        <l-footer :theme="'white'"></l-footer>
    </main>
</template>

<script>
    import lCHeader from "@/views/cabinet/header-cabinet";
    import lFooter from "@/views/footer";
    import CMenu from "@/views/cabinet/cabinet/menu";
    import widthMixin from '@/modules/mixins/widthMixin'
    import productAdapter from '@/modules/productAdapter';
    import dotObject from 'dot-object';

    import paymentPopup from '@/views/cabinet/cabinet/popups/paymentPopup'
    import popupPaymentSchedule from '@/views/cabinet/cabinet/popups/popupPaymentSchedule'

    export default {
        name: "Layout",
        mixins: [widthMixin],
        data() {
            return {
                product: '',
                paymentSum: '',
                HowNeed: '',
            }
        },
        components: {
            lCHeader,
            lFooter,
            CMenu,
            paymentPopup,
            popupPaymentSchedule
        },
        methods: {
            goToCalculator(){
                let _this = this;
                _this.$http.get('/scheduleAndGESV', {params: {
                        term: _this.$store.getters['calculator/getField']('term'),
                        amount: _this.$store.getters['calculator/getField']('amount'),
                        productId: _this.$store.getters['calculator/getField']('productID'),
                        calculationType: _this.$store.getters['calculator/getField']('creditType')
                    }
                }).then(
                    response => {
                        if(response.data.code === 0){
                            if( !response.data.data.exceeds){
                                _this.$http.get('/json/profile').then(
                                    (response) => {
                                        if(response.data.code === 0){
                                            debugger;
                                            let object = dotObject.dot(response.data.data);
                                            if( _this.notNullAndEmpty(object['identityData.expirationDate']) ){
                                                _this.$router.push({name: 'PassportData'})
                                            }
                                            else if( _this.notNullAndEmpty(object['personalData.stationaryPhone']) ){
                                                _this.$router.push({name: 'Address'})
                                            }
                                            else if( _this.notNullAndEmpty(object['employment.employmentType'] )){
                                                _this.$router.push({name: 'Employment'})
                                            }
                                            else if(_this.notNullAndEmpty(object['contacts.1.firstName']) ){
                                                _this.$router.push({name: 'RelativeContacts'})
                                            }
                                            else{
                                                _this.$router.push({name: 'Refining'})
                                            }
                                        }
                                    },
                                    (response) => {

                                    }
                                )
                            }else{
                                _this.$modal.show('gesv-error');
                            }
                        }
                    },
                    response => {}
                );
            },
            notNull(field){
              return 'null' != field;
            },
            notEmpty(field){
              return '' != field;
            },

            notNullAndEmpty(field){
              return this.notNull(field) && this.notEmpty(field);
            },

            setPayment() {
                this.paymentSum = Math.ceil(this.currentLoan.MonthlyPayment);
                this.HowNeed = Math.ceil(this.currentLoan.MonthlyPayment);
            },
            paymentClick() {
                let data = new URLSearchParams();
                data.append('creditId', this.currentLoan.documentNumber);
                data.append('amount', this.paymentSum);
                this.$http.post('/json/payment/processing-kz/simple-payment', data).then(
                    (response) => {
                        if (response.data.code === 300) {
                            window.location.replace(response.data.redirect.value);
                        }
                    },
                    (response) => {

                    }
                )
            }
        },
        computed: {
            showCalculator: function () {
                return this.creditStatus !== 'ACTIVE' && this.creditStatus !== 'EXPIRED'; /// TODO: Поправить все вот это вот
            },
            showPaymentShedule: function () {
                return this.creditStatus === 'ACTIVE' || this.creditStatus === 'EXPIRED';
            },
            creditStatus: function () {
                return this.$store.getters['credit/getField']('creditStatus');
            },
            currentLoan: function () {
                return this.$store.getters['current/getCurrentLoan']
            },


        },
        mounted() {
            this.$store.dispatch('credit/GET_CREDIT_INFO');
            this.$store.dispatch('current/getCurrentCredit');
            let _this = this;
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
            this.$http.get('/json/product').then(
                response => {
                    if (response.data.code === 0) {
                        let product = productAdapter.getActiveProduct(response.data.data.available, "MicroProductEngine");
                        this.$store.commit('calculator/updateField', {path: 'productID', value:product.id});
                        _this.product = productAdapter.transformProduct(product);
                    }
                },
                response => {
                }
            );
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .cabinet__column .calculator{
        position: relative;
        width: 310px;
        max-width: 320px;
        left: -10px;
        margin: 0;
    }
    .fade-enter-active {
        transition: opacity .5s;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-leave-active {
        display: none;
    }

    .fade-leave-to {
        display: none;
    }

    .layout {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        .content {
            flex: 1;
        }
    }

    .modal-wrap {
        padding: 15px;
        &__title {
            font-family: $RobotoRegular;
            font-size: 24px;
            text-align: center;
            padding: 5px 15px;
        }
        &__info-wrap {
            max-width: 300px;
            margin: 10px auto;
            display: flex;
            justify-content: space-between;
            padding: 10px 15px;
            background-color: rgba(240, 240, 240, 0.5);
        }
        &__info-content {
        }
        &__input-wrap {
            max-width: 320px;
            margin: 0 auto;
        }
        &__button-wrap {
            max-width: 300px;
            margin: 0 auto;
        }
        &__button {
            max-width: 100%;
            width: 100%;
        }
    }

    @media screen and (max-width: 1024px) {
        .content {
            padding-top: 48px;
            &__cabinet {
                padding-top: 0;
                margin-top: 0;
            }
        }
        .layout {

        }
    }
    @media screen and (max-width: 768px) {
        .modal-wrap {
            padding: 15px;
            &__title {
                font-family: $RobotoRegular;
                font-size: 20px;
                text-align: center;
                padding: 5px 15px;
            }
            &__info-wrap {
                max-width: 270px;
                margin: 10px auto;
                display: flex;
                justify-content: space-between;
                padding: 10px 15px;
                background-color: rgba(240, 240, 240, 0.5);
            }
            &__info-content {
            }
            &__input-wrap {
                max-width: 320px;
                margin: 0 auto;
            }
            &__button-wrap {
                max-width: 270px;
                margin: 0 auto;
            }
            &__button {
                max-width: 100%;
                width: 100%;
            }
        }
    }

</style>
